import { TableUIProvider } from "../../contexts/TableUIContext";
import Classrooms from "./Classrooms";

export default function ClassroomsWrapper() {
    return (
        <TableUIProvider>
            <Classrooms />
        </TableUIProvider>
    );
}
